export const DEFAULT_AVATAR_URL: string = "assets/images/default-avatar.png";